<template>
  <div>
    <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActive = true">テンプレート</vs-button>
    <vs-popup class="attachment-popup" title="" :active.sync="popupActive" :button-close-hidden="true">
    <div class="vx-row template">
      <div class="vx-col md:w-1/1 w-full mb-base">
      <vs-card>
        <table class="w-full mb-4">
          <tr>
            <td>付属書類テンプレート選択</td>
          </tr>
          <tr>
            <td>
              <div class="flex items-center">
                <vs-checkbox v-model="formData.m" id="m" class="mr-4" :disabled="formData.m && atleastCheckbox">マンション</vs-checkbox>
                <vs-checkbox v-model="formData.h" id="h" class="mr-4" :disabled="formData.h && atleastCheckbox">戸建</vs-checkbox>
                <vs-checkbox v-model="formData.l" id="l" class="mr-4" :disabled="formData.l && atleastCheckbox">土地</vs-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex items-center jutify-start">
                <span class="mr-2">ページ内検索：</span>
                <vs-input v-model="formData.search_key" class="w-full input-search mr-2"></vs-input>
                <vs-button class="primary btn-search flex items-center btn-positive" color="positive" type="filled" text-color="#7367F0" @click="search">検索・次へ</vs-button>
              </div>
            </td>
          </tr>
        </table>
        <div class="vx-row mb-4">
          <div class="vx-col">
            <vs-button class="h-12" @click="clearAllCheckbox">チェック全クリア</vs-button>
          </div>
        </div>
        <div class="w-full datatable" id="datatable_container">
          <table class="w-full mb-4">
            <thead>
              <tr class="tbl-header">
                <th>IV  付属書類</th>
                <th>種類</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in document" :key="index" :class="`tbl-row-${index} ${formData.search_key && searchFoundIndex === index ? 'bg-hightline' : ''}`">
                <td>
                  <div>
                    <vs-checkbox v-model="row.selected">{{row.name}}</vs-checkbox>
                  </div>
                </td>
                <td>{{row.type}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="vx-row mb-2 mt-2">
          <div class="vx-col right" >
            <vs-button class="mr-8 primary h-12 btn-positive" color="positive" type="filled" text-color="#7367F0" @click="selectTemplates">追加</vs-button>
            <vs-button class="h-12" @click="popupActive=false">キャンセル</vs-button>
          </div>
        </div>
      </vs-card>
      </div>
    </div>
  </vs-popup>
  </div>
</template>

<script>
import _ from 'lodash'
import { GET_FUZOKUSHORUI_LIST } from '@/store/modules/keiyaku/actions'

export default {
  name: 'AttachmentTemplate',
  props: {
    title:{
      type: String
    },
    show: {
      type: String
    },
    kubun: {
      type: Number
    }
  },
  data() {
    return {
      formData: {
        m: false, // M
        h: false, // H
        l: false, // L
        search_key: ''
      },
      document: {
        data: []
      },
      originalDocument: null,
      formChange: false,
      searchFoundIndex: -1,
      popupActive: false,
      popupCancel: false
    }
  },
  mounted() {
    this.getTemplates(
      (data) => {
        this.originalDocument = data
        this.document = _.cloneDeep(data)
      },
      () => {
        this.originalDocument = []
        this.document = []
      }
    )
    if(this.kubun !== null) {
      if(this.kubun === 0) {
        this.formData.l = true
      }
      if(this.kubun === 1) {
        this.formData.h = true
      }
      if(this.kubun === 2) {
        this.formData.m = true
      }
      this.formChange = true
      setTimeout(() => {
        this.search()
      }, 200)
    }
  },
  watch: {
    formData: {
      handler() {
        this.formChange = true
      },
      deep: true
    }
  },
  computed: {
    atleastCheckbox() {
      return Object.keys(this.formData).filter(key => this.formData[key] === true).length === 1
    }
  },
  methods: {
    getTemplates(_onSuccess, _onError) {
      let types = ''
      Object.keys(this.formData).filter(key => this.formData[key] === true).forEach((key, idx) => {
        types += idx === 0 ? key.toUpperCase() : `,${key.toUpperCase()}`
      })
      const params = {
        type: types,
        name: ''
      }
      this.$store.dispatch(GET_FUZOKUSHORUI_LIST, params).then((data) => {
        _onSuccess(data)
      }).catch((error) => {
        _onError(error)
      })
    },
    resetData() {
      // reset selected template when popup close
      this.formChange = true
      setTimeout(() => {
        this.search()
      }, 200)
    },
    search() {
      if (this.formChange) {
        this.getTemplates((data) => {
          this.originalDocument = data
          this.document = _.cloneDeep(data)
          this.formChange = false
          this.searchFoundIndex = -1
          if (this.document.length) {
            // scroll to top when re-search
            this.scroll()
          }
        },
        (error) => {
          this.$toasted.error(error)
        })
      } else {
        this.scroll()
      }
    },
    scroll() {
      if (this.formData.search_key && this.formData.search_key.trim()) {
        const searchKeyTrim = this.formData.search_key.trim()
        let found = -1
        for (let i = 0; i < this.document.length; i++) {
          if (this.document[i].name.includes(searchKeyTrim)) {
            found = 0
            if (i > this.searchFoundIndex) {
              found = 1
              this.searchFoundIndex = i
              const ele = document.getElementsByClassName(`tbl-row-${i}`)[0]
              if (ele) {
                ele.scrollIntoView({behavior: 'smooth'})
              }
              break
            }
          }
        }
        if (found === 0) {
          this.searchFoundIndex = -1
          this.scroll()
        }
      } else {
        const ele = document.getElementsByClassName('tbl-header')[0]
        if (ele) {
          ele.scrollIntoView({behavior: 'smooth'})
        }
      }
    },
    clearAllCheckbox() {
      const document = [...this.document]
      document.forEach((item) => {
        if(item.selected) {
          item.selected = false
        }
      })
      this.document = document
    },
    cancelTemplateSelection() {
      this.popupCancel = false
      setTimeout(() => {
        this.$emit('onclose')
        this.resetData()
        this.popupActive = false
      }, 100)
    },
    selectTemplates() {
      const selectedTemplates = this.document.filter(item => item.selected)
      if (!selectedTemplates.length) {
        this.$toasted.error('項目が選択されていません。')
        return
      }
      this.$emit('onselect', selectedTemplates)
      this.resetData()
      this.popupActive = false
    }
  }
}
</script>

<style scoped>
.template {
  font-weight: bold;
}
.template table {
  border-spacing: 0;
  border-collapse: collapse;
}
.template table thead th {
  background-color: #7367f0;
  color: #fff;
  padding: 0.8rem;
}
.template table th, .template table td {
  border: 1px solid #b8c2cc;
  font-size: 0.85rem;
  padding: 0.5rem;
}
.input-search {
  max-width: 350px;
}
.btn-search {
  height: 37px;
}

.attachment-popup {
    font-weight: bold;
}

.attachment-popup /deep/ table {
  border-collapse: collapse;
}

.attachment-popup /deep/ td, th {
    border: 1px solid #b8c2cc;
    padding: 0.5rem;
}

.attachment-popup /deep/ .vs-popup {
    width: 700px !important;
}

.attachment-popup /deep/ .vs-popup--header {
  display: none;
}
.attachment-popup .datatable {
  max-height: 300px;
  overflow-y: scroll;
}
.bg-hightline {
  background: #eaeabe;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.right {
  margin: 0 0 0 auto;
}
</style>
